"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GatewayKnownOps = exports.GatewayTransactionStates = exports.GatewayBatchStates = void 0;
var GatewayBatchStates;
(function (GatewayBatchStates) {
    GatewayBatchStates["Queued"] = "Queued";
    GatewayBatchStates["Delayed"] = "Delayed";
    GatewayBatchStates["Sending"] = "Sending";
    GatewayBatchStates["Sent"] = "Sent";
    GatewayBatchStates["Reverted"] = "Reverted";
    GatewayBatchStates["Canceled"] = "Canceled";
})(GatewayBatchStates = exports.GatewayBatchStates || (exports.GatewayBatchStates = {}));
var GatewayTransactionStates;
(function (GatewayTransactionStates) {
    GatewayTransactionStates["Sending"] = "Sending";
    GatewayTransactionStates["Sent"] = "Sent";
    GatewayTransactionStates["Canceling"] = "Canceling";
    GatewayTransactionStates["Canceled"] = "Canceled";
    GatewayTransactionStates["Reverted"] = "Reverted";
})(GatewayTransactionStates = exports.GatewayTransactionStates || (exports.GatewayTransactionStates = {}));
var GatewayKnownOps;
(function (GatewayKnownOps) {
    GatewayKnownOps["WithdrawP2PDeposit"] = "WithdrawP2PDeposit";
})(GatewayKnownOps = exports.GatewayKnownOps || (exports.GatewayKnownOps = {}));
